import { ScrollableAreaTabFooter } from "@ofqual/portal-components/components/ScrollableAreaTabFooter";
import {
  ScrollableAreaTab,
  ScrollableAreaTabSkeleton,
} from "@ofqual/portal-components/components/ScrollableAreaTab";
import { RecipientsItem } from "./RecipientsItem";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  List,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { ActionType } from "./types";
import { buildActions } from "./buildActions";
import { RenderDialog } from "./RenderDialog";
import { RecipientOrg } from "../../../domain/RecipientsViewModel";
import { useDispatch } from "react-redux";
import { toggleSelectRecipient } from "../../../redux/actions";
import { NonNullableRecipientsState } from "../../../redux/state";
import { InformationRequest } from "../../../domain/InformationRequest";

export type RecipientsProps = {
  recipientsState: NonNullableRecipientsState | null;
  disabled: boolean;
  informationRequest: InformationRequest;
  isDraft: boolean;
};

export const Recipients: React.FC<RecipientsProps> = ({
  recipientsState,
  disabled,
  informationRequest,
  isDraft
}) => {
  const [focussedEntity, setFocussedEntity] = useState<ActionType | null>(null);
  const dispatch = useDispatch();

  const recipients = recipientsState?.viewModel;

  const actions = buildActions(
    (entity) => setFocussedEntity(entity),
    disabled,
    recipients,
    isDraft
  );

  const areAllCheckboxesChecked = recipients?.orgs.length
    ? recipients.orgs.every((recipient) => recipient.isSelected)
    : false;

  const onToggleSelectRecipient = (recipient: RecipientOrg) =>
    dispatch(toggleSelectRecipient([recipient]));

  const toggleSelectAll = () =>
    recipients?.orgs && dispatch(toggleSelectRecipient(recipients.orgs));

  return (
    <>
      {recipients ? (
        <>
          <ScrollableAreaTab hasActions={!!actions.length}>
            {recipients.orgs.length ? (
              <>
                <FormControlLabel
                  value="selectAll"
                  control={<Checkbox checked={areAllCheckboxesChecked} />}
                  label={
                    <Typography variant="subtitle2">
                      Select/Deselect All
                    </Typography>
                  }
                  labelPlacement="end"
                  onChange={toggleSelectAll}
                />
                <Divider />
                <List>
                  {recipients.orgs.map((item) => (
                    <RecipientsItem
                      key={item.id}
                      recipientOrg={item}
                      toggleSelectRecipient={onToggleSelectRecipient}
                    />
                  ))}
                </List>
              </>
            ) : (
              <Typography
                variant="h4"
                style={{ textAlign: "center", textTransform: "uppercase" }}
                color="textSecondary"
              >
                None
              </Typography>
            )}
          </ScrollableAreaTab>
          <ScrollableAreaTabFooter actions={actions} />
          <RenderDialog
            focussedEntity={focussedEntity}
            onClose={() => setFocussedEntity(null)}
            recipients={recipients}
            informationRequest={informationRequest}
          />
        </>
      ) : (
        <ScrollableAreaTabSkeleton hasActions={!!actions.length} />
      )}
    </>
  );
};
